export { default } from './SecurityFooter';
